/**
 * everything needed to create modals
 */
export class PoprModalPackage {
  constructor(public config: {
    title?: string | undefined;
  }) {}
}
